module.exports = __webpack_public_path__ + "img/lunchly_logo_small.a55811ac.png";